














import { ExpenseType, FinanceType, LoadingStatusType, TransactionItemType, TransactionType } from "@/enums/enums";
import { SettingTaxInvoiceModel } from "@/model/setting";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreSetting = namespace("Setting");

@Component
export default class SectionDescription extends Vue {
  @Prop({}) readonly transactionCreate!: any;

  @StoreSetting.Getter
  private getSettingTransactionRemarkLoadingStatus!: LoadingStatusType;
  @StoreSetting.Getter
  private getSettingTransactionRemark!: Array<SettingTaxInvoiceModel>;
  @StoreSetting.Action
  private DoGetSettingTransactionRemark!: () => void;

  @Watch("getSettingTransactionRemarkLoadingStatus", { immediate: true })
  getSettingTransactionRemarkLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.SetTransactionSettingRemark();
    }
  }

  public SetTransactionSettingRemark() {
    if (this.getSettingTransactionRemark && this.getSettingTransactionRemark.length > 0) {
      let settingTransaction: any = null;

      if (
        this.transactionCreate.transactionType == TransactionType.Invoice &&
        this.transactionCreate.financeType == FinanceType.OutFlow &&
        this.transactionCreate.expenseType == ExpenseType.PurchaseAsset
      ) {
        settingTransaction = this.getSettingTransactionRemark.find(
          (x: any) =>
            x.transactionType === this.transactionCreate.transactionType &&
            x.financeType === this.transactionCreate.financeType &&
            x.transactionItemType == TransactionItemType.Asset
        );
      } else {
        settingTransaction = this.getSettingTransactionRemark.find(
          (x: any) =>
            x.transactionType === this.transactionCreate.transactionType &&
            x.financeType === this.transactionCreate.financeType
        );
      }

      if (settingTransaction && settingTransaction.remark != "" && !this.transactionCreate.remark.isNotAuto) {
        this.transactionCreate.remark.text = settingTransaction.remark;
      }
    }
  }
}
